module.exports = __webpack_public_path__ + "static/media/mouicon.bbc98cd2.svg";